export type BoardNotFoundStateVariant = 'invalid-link' | 'branch-not-found'

export const BOARD_NOT_FOUND_STATE_TEXTS: Record<
    BoardNotFoundStateVariant,
    { title: string; description: string }
> = {
    'invalid-link': {
        title: 'Ссылка неверная',
        description: 'Откройте доску очереди по ссылке филиала',
    },
    'branch-not-found': {
        title: 'Филиал не найден',
        description: 'Филиал удалён или неактивен. Обратитесь к администратору',
    },
}
